import React from 'react';
import { ThemeProvider } from '../../contexts/ThemeContext';
import { FontProvider } from '../../contexts/FontContext';

const AppLayout = ({ children }) => {
  return (
    <ThemeProvider>
      <FontProvider>
        {children}
      </FontProvider>
    </ThemeProvider>
  );
};

export default AppLayout;